const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.808,
    height: 41.808,
    viewBox: "0 0 41.808 41.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1011"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5222",
    d: "M33.156 40.808H7.651A7.651 7.651 0 0 1 0 33.156V7.651A7.651 7.651 0 0 1 7.651 0h25.5a7.651 7.651 0 0 1 7.651 7.651v25.5a7.651 7.651 0 0 1-7.646 7.657zm0 0",
    transform: "translate(.5 .5)",
    style: {
      fill: "#f9f9f9",
      stroke: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.37 18.27 2.378 2.378V10.8a.8.8 0 1 1 1.607 0v9.845l2.378-2.378a.8.8 0 0 1 1.136 1.136l-3.749 3.753q-.028.028-.059.053l-.027.02-.034.027-.034.021-.033.02-.035.017-.036.017-.035.013-.039.014-.035.009-.041.01-.04.006-.037.005H84.477l-.036-.005-.041-.006-.04-.01-.036-.009-.038-.013-.036-.013-.035-.016-.037-.018-.032-.019-.036-.022-.034-.025-.029-.022a.677.677 0 0 1-.056-.051l-3.749-3.75a.8.8 0 0 1 1.128-1.139z",
    transform: "translate(-63.648 -.827)",
    style: {
      fill: "#faa100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.873 160a.8.8 0 0 0-.8.8v6.16H1.607v-6.16a.8.8 0 1 0-1.607 0v6.964a.8.8 0 0 0 .8.8h16.07a.8.8 0 0 0 .8-.8V160.8a.8.8 0 0 0-.797-.8z",
    transform: "translate(12.066 -140.493)",
    style: {
      fill: "#faa100"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOutline);
export default __webpack_public_path__ + "static/media/downloadOutline.ca5ec7e73b88d1ef0725d8505cc22dca.svg";
export { ForwardRef as ReactComponent };